import React from "react";
import Modal from "./Modal";

export default function LeaderboardModal({ open, onClose, leaders, handle }) {
  return (
    <Modal open={open} onClose={onClose} title="🏆 Global Lab Leaderboard" testId="leaderboard-modal" wide tint="sun">
      <p className="text-[var(--ink-soft)] text-sm mb-4">
        Ranked by Lab Score · brain + heart × 10 + fact-checks × 250 + balanced × 500.
      </p>
      <div className="space-y-2.5" data-testid="leaderboard-list">
        {(leaders || []).map((l, i) => {
          const isMe = l.handle === handle;
          const podiumColors = ["rgba(255,198,41,0.22)", "rgba(229,231,235,0.15)", "rgba(253,186,116,0.18)"];
          const podiumBorders = ["var(--sun)", "rgba(229,231,235,0.5)", "rgba(253,186,116,0.6)"];
          return (
            <div
              key={l.handle}
              className="card-flat"
              style={{
                background: isMe ? "linear-gradient(180deg, rgba(255,198,41,0.18), rgba(255,198,41,0.05))" : undefined,
                borderColor: isMe ? "rgba(255,198,41,0.5)" : undefined,
              }}
              data-testid={`leaderboard-row-${i}`}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                  <div
                    className="w-11 h-11 rounded-full flex items-center justify-center font-display text-xl shrink-0"
                    style={{
                      background: i < 3 ? podiumColors[i] : "rgba(255,255,255,0.05)",
                      color: "white",
                      border: `1.5px solid ${i < 3 ? podiumBorders[i] : "var(--line-strong)"}`,
                    }}
                  >
                    {i + 1}
                  </div>
                  <div className="min-w-0">
                    <div className="font-display text-[var(--ink)] truncate">
                      {l.scientist_name} {isMe && <span className="text-[var(--sun)] text-xs">(you!)</span>}
                    </div>
                    <div className="label-tag truncate">@{l.handle}</div>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <div className="stat-num text-2xl text-[var(--ink)]">{l.neurocardio_score.toLocaleString()}</div>
                  <div className="label-tag">{l.entries} entries</div>
                </div>
              </div>
            </div>
          );
        })}
        {(!leaders || leaders.length === 0) && (
          <div className="text-center text-[var(--ink-soft)] py-8">🪐 Be the first scientist!</div>
        )}
      </div>
    </Modal>
  );
}
